"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SupportFeatureGrid = exports.SupportFeature = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _styles = require("./shared/styles");

var _excluded = ["image", "title", "desc", "children", "layout"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Image = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq6"
} : {
  target: "e1r3ustq6",
  label: "Image"
})(process.env.NODE_ENV === "production" ? {
  name: "o11quc",
  styles: "margin-right:20px;flex:none;svg,img{display:block;width:40px;height:auto;}"
} : {
  name: "o11quc",
  styles: "margin-right:20px;flex:none;svg,img{display:block;width:40px;height:auto;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Title = (0, _theming.styled)("h2", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq5"
} : {
  target: "e1r3ustq5",
  label: "Title"
})(_styles.text.largeBold, ";color:", _styles.color.darkest, ";margin-bottom:0.25rem;");
var Desc = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq4"
} : {
  target: "e1r3ustq4",
  label: "Desc"
})(_styles.text.large, ";color:#586368;");
var Meta = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq3"
} : {
  target: "e1r3ustq3",
  label: "Meta"
})(function (props) {
  return props.horizontal && /*#__PURE__*/(0, _theming.css)("width:100%;display:flex;flex-direction:column;@media (min-width: ", _styles.breakpoints[2], "px){flex-direction:row;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Meta;"));
}, ";");

var _ref = process.env.NODE_ENV === "production" ? {
  name: "80byvz",
  styles: "margin-top:0.5rem;display:flex;gap:16px"
} : {
  name: "1jncvmb-ChildrenWrapper",
  styles: "margin-top:0.5rem;display:flex;gap:16px;label:ChildrenWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ChildrenWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq2"
} : {
  target: "e1r3ustq2",
  label: "ChildrenWrapper"
})(function (props) {
  return props.horizontal ? /*#__PURE__*/(0, _theming.css)("flex:1 1 auto;margin-top:0.5rem;@media (min-width: ", _styles.breakpoints[2], "px){margin-top:0;margin-left:30px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:ChildrenWrapper;")) : _ref;
}, ";");
var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq1"
} : {
  target: "e1r3ustq1",
  label: "Wrapper"
})("padding:30px;border-radius:", _styles.spacing.borderRadius.small, "px;border:1px solid ", _styles.color.border, ";display:flex;");

var SupportFeature = function SupportFeature(_ref2) {
  var image = _ref2.image,
      title = _ref2.title,
      desc = _ref2.desc,
      children = _ref2.children,
      _ref2$layout = _ref2.layout,
      layout = _ref2$layout === void 0 ? 'vertical' : _ref2$layout,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, /*#__PURE__*/_react["default"].createElement(Image, null, image), /*#__PURE__*/_react["default"].createElement(Meta, {
    horizontal: layout === 'horizontal'
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Title, null, title), /*#__PURE__*/_react["default"].createElement(Desc, null, desc)), children && /*#__PURE__*/_react["default"].createElement(ChildrenWrapper, {
    horizontal: layout === 'horizontal'
  }, children)));
};

exports.SupportFeature = SupportFeature;
var SupportFeatureGrid = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3ustq0"
} : {
  target: "e1r3ustq0",
  label: "SupportFeatureGrid"
})("display:grid;gap:30px;grid-template-columns:1fr;margin:0 auto;@media (min-width: ", _styles.breakpoints[2], "px){grid-template-columns:1fr 1fr;}");
exports.SupportFeatureGrid = SupportFeatureGrid;